"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAIR_ROW_HEIGHT = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const decimal_js_1 = __importDefault(require("decimal.js"));
const constants_1 = require("src/constants");
const tokenTags_1 = require("src/misc/tokenTags");
const utils_1 = require("src/misc/utils");
const TokenIcon_1 = __importDefault(require("./TokenIcon"));
const TokenLink_1 = __importDefault(require("./TokenLink"));
const Coinbalance_1 = __importDefault(require("./Coinbalance"));
const CheckedBadge_1 = __importDefault(require("./CheckedBadge"));
const useLstApy_1 = require("src/queries/useLstApy");
const useBalances_1 = require("src/hooks/useBalances");
const react_query_1 = require("@tanstack/react-query");
const useAsset_1 = require("src/hooks/useAsset");
exports.PAIR_ROW_HEIGHT = 72;
const LSTTag = ({ mintAddress }) => {
    const { data: lstApy } = (0, useLstApy_1.useLstApyFetcher)();
    const apy = (0, react_1.useMemo)(() => {
        if (!lstApy)
            return;
        const value = lstApy.apys[mintAddress];
        if (value && (0, utils_1.hasNumericValue)(value)) {
            return new decimal_js_1.default(value).mul(100).toDP(2).toString();
        }
        return;
    }, [lstApy, mintAddress]);
    return ((0, jsx_runtime_1.jsxs)("p", { className: "rounded-md text-xxs leading-none transition-all py-0.5 px-1 text-primary/50 border border-primary/50 font-semibold", children: ["LST ", apy ? `${apy}%` : ''] }));
};
const MultiTags = ({ item }) => {
    const { data: balances } = (0, useBalances_1.useBalances)();
    const isLoading = (0, react_1.useRef)(false);
    const isLoaded = (0, react_1.useRef)(false);
    // It's cheaper to slightly delay and rendering once, than rendering everything all the time
    const [renderedTag, setRenderedTag] = react_1.default.useState({
        isVerified: false,
        isLST: false,
        // isUnknown: false,
        isToken2022: false,
        isFrozen: false,
    });
    (0, react_1.useEffect)(() => {
        if (isLoaded.current || isLoading.current)
            return;
        isLoading.current = true;
        setTimeout(() => {
            var _a, _b;
            const result = {
                isVerified: (0, tokenTags_1.checkIsStrictOrVerified)(item),
                isLST: Boolean((_a = item.tags) === null || _a === void 0 ? void 0 : _a.includes('lst')),
                // isUnknown: checkIsUnknownToken(item),
                isToken2022: Boolean((0, tokenTags_1.checkIsToken2022)(item)),
                isFrozen: ((_b = balances === null || balances === void 0 ? void 0 : balances[item.id]) === null || _b === void 0 ? void 0 : _b.isFrozen) || false,
            };
            setRenderedTag(result);
            isLoading.current = false;
            isLoaded.current = true;
        }, 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const remainingTags = []; // we use to show 'pump'
    if (!renderedTag)
        return null;
    const { isToken2022, isFrozen, isLST } = renderedTag;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex justify-end gap-x-1", children: [isFrozen && ((0, jsx_runtime_1.jsx)("p", { className: "border rounded-md text-xxs leading-none transition-all py-0.5 px-1 border-warning/50 text-warning/50", children: "Frozen" })), isToken2022 && ((0, jsx_runtime_1.jsx)("p", { className: "rounded-md text-xxs leading-none transition-all py-0.5 px-1 bg-black/10 font-semibold text-primary-text/20", children: "Token2022" })), remainingTags === null || remainingTags === void 0 ? void 0 : remainingTags.map((tag, idx) => ((0, jsx_runtime_1.jsx)("div", { className: "rounded-md text-xxs leading-none transition-all py-0.5 px-1 bg-black/10 font-semibold text-primary-text/20", children: tag }, idx))), isLST && (0, jsx_runtime_1.jsx)(LSTTag, { mintAddress: item.id })] }));
};
const FormPairRow = (props) => {
    var _a;
    const { item, style, onSubmit, suppressCloseModal, showExplorer = true, enableUnknownTokenWarning = true, } = props;
    const queryClient = (0, react_query_1.useQueryClient)();
    const onClick = react_1.default.useCallback(() => {
        // Optimistically update for useAsset hook
        queryClient.setQueryData([...useAsset_1.ASSET_QUERY_KEY, item.id], [item]);
        onSubmit(item);
        if (suppressCloseModal)
            return;
    }, [onSubmit, item, suppressCloseModal, queryClient]);
    const { data: balances } = (0, useBalances_1.useBalances)();
    const balance = (_a = balances === null || balances === void 0 ? void 0 : balances[item.id]) === null || _a === void 0 ? void 0 : _a.uiAmount;
    const usdValue = balance ? new decimal_js_1.default(balance).mul(item.usdPrice || 0) : undefined;
    const usdValueDisplay = usdValue && usdValue.gte(0.01) // If smaller than 0.01 cents, dont show
        ? `$${utils_1.formatNumber.format(usdValue, 2)}` // USD value can hardcode to 2
        : '';
    return ((0, jsx_runtime_1.jsx)("li", { className: `rounded cursor-pointer px-5 my-1 list-none flex w-full items-center bg-interactive hover:bg-interactive/80`, style: Object.assign({ maxHeight: exports.PAIR_ROW_HEIGHT - 4, height: exports.PAIR_ROW_HEIGHT - 4 }, style), onClick: onClick, translate: "no", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex h-full w-full items-center space-x-4", children: [(0, jsx_runtime_1.jsx)("div", { className: "flex-shrink-0", children: (0, jsx_runtime_1.jsx)("div", { className: "bg-gray-200 rounded-full", children: (0, jsx_runtime_1.jsx)(TokenIcon_1.default, { info: item, width: 36, height: 36, enableUnknownTokenWarning: enableUnknownTokenWarning }) }) }), (0, jsx_runtime_1.jsx)("div", { className: "flex-1 min-w-0", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-y-px", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex items-center", children: [(0, jsx_runtime_1.jsx)("p", { className: "text-sm font-medium text-primary-text truncate", children: item.symbol }), (0, tokenTags_1.checkIsStrictOrVerified)(item) && ((0, jsx_runtime_1.jsx)("p", { className: "rounded-md text-xxs leading-none transition-all py-0.5 px-1 text-primary", children: (0, jsx_runtime_1.jsx)(CheckedBadge_1.default, { width: 18, height: 18 }) }))] }), (0, jsx_runtime_1.jsx)("p", { className: "text-xs text-primary-text/50 dark:text-primary-text-35 truncate", children: item.id === constants_1.WRAPPED_SOL_MINT.toBase58() ? 'Solana' : item.name }), showExplorer ? ((0, jsx_runtime_1.jsx)("div", { className: "-ml-1 z-10 w-fit", onClick: (e) => e.stopPropagation(), children: (0, jsx_runtime_1.jsx)(TokenLink_1.default, { tokenInfo: item }) })) : null] }) }), (0, jsx_runtime_1.jsxs)("div", { className: "text-xs text-primary-text/50 text-right h-full flex flex-col justify-evenly", children: [(0, jsx_runtime_1.jsx)(Coinbalance_1.default, { mintAddress: item.id, hideZeroBalance: true }), usdValueDisplay ? (0, jsx_runtime_1.jsx)("p", { children: usdValueDisplay }) : null, (0, jsx_runtime_1.jsx)(MultiTags, Object.assign({}, props))] })] }) }));
};
exports.default = FormPairRow;
